import { Component, EventEmitter, input, OnInit, Output } from '@angular/core';
import { topUpSelectOptions } from '../../../../pages/management/card-topups/utils/utils';
import { NgClass } from '@angular/common';
import { TopUpFrequency } from '../../../../_interfaces/employee.interface';

@Component({
  selector: 'app-select-topup-frequency',
  imports: [NgClass],
  template: `
    <p class="form-label">How often should we check the card balance?</p>
    <div class="row mb-3">
      @for (option of selectOptions; track option) {
        <div class="col">
          <div class="form-check input-radio-select input-radio-select-right">
            <input
              class="form-check-input"
              [checked]="option.checked"
              (change)="onSelectOption(option.value)"
              type="radio"
              name="optionFields"
              [id]="'option_' + option.value" />
            <label
              class="form-check-label"
              [ngClass]="{ 'border-secondary': option.checked }"
              [for]="'option_' + option.value">
              {{ option.label }}
            </label>
          </div>
        </div>
      } @empty {
        <p class="text-muted">No options available</p>
      }
    </div>
  `,
})
export class SelectTopupFrequencyComponent implements OnInit {
  initialValue = input<TopUpFrequency | null>();
  @Output() frequencyChange: EventEmitter<TopUpFrequency> = new EventEmitter<TopUpFrequency>();
  protected readonly selectOptions = topUpSelectOptions;

  onSelectOption(value: TopUpFrequency) {
    for (const option of this.selectOptions) {
      option.checked = option.value === value;
    }
    const selectedOption = this.selectOptions.find((option) => option.checked);
    this.frequencyChange.emit(selectedOption?.value);
  }

  ngOnInit(): void {
    this.onSelectOption(this.initialValue() ?? TopUpFrequency.Monthly);
  }
}
